import { useMemo } from "react";
import { useGetQueuesForCurrentUser } from "./WorkingPlacesTable/useGetQueuesForCurrentUser";

export function useAdminQueueIdsFilter(): {
  queueIdsFilter?: number[];
  isLoadingQueueIdsFilter: boolean;
} {
  // Берём привязки очередей текущего пользователя с бэкенда.
  // Это гарантирует, что на разных страницах (Терминал/Табло) будет одна и та же выборка.
  const { queues, isLoading } = useGetQueuesForCurrentUser(true);
  const apiQueueIds = useMemo(() => queues.map((q) => q.id), [queues]);
  // Пустой список = нет ограничения (орг. админ без привязки к очередям видит все).
  const queueIdsFilter = apiQueueIds.length > 0 ? apiQueueIds : undefined;

  return {
    queueIdsFilter,
    isLoadingQueueIdsFilter: isLoading,
  };
}
